<template>
  <div>
    <v-card>
      <template>
        <v-alert color="primary" border="left" elevation="2" colored-border>
            <v-row no-gutters>
              <v-col cols="md-10 sm-12">
                <p class=" lg-6 ml-2">
                  TOTAL : <strong>{{ multas.total }} </strong>
                </p>
              </v-col>
              <v-col>
                <v-btn
                  @click="download()"
                  color="primary"
                  dark
                  col="lg-6 md-12 sm-12 xs-12"
                >
                  Exportar dados
                </v-btn>
              </v-col>
            </v-row>
        </v-alert>
      </template>

      <v-card-text>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="multas.data"
          hide-default-footer
          :items-per-page="50"
        >
          <template v-slot:body="{ items }">
            <tbody v-for="item in items" :key="item.id">
              <tr class="text-left">
                <td>{{ item.autos }}</td>
                <td>{{ item.codigo }}-{{ item.digito }}</td>
                <td>{{ item.veiculo_tipo || "---" }}</td>
                <td>{{ item.infracao_logradouro }}</td>
                <td>{{ item.descricao }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <paginate-component
          v-if="multas !== undefined"
          :pagination="multas"
          @paginate="pagination($event)"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import PaginateComponent from "@/components/Paginate";
import queryString from "query-string";
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";

export default {
  name: "TabelaMultasInfracao",
  props: {
    multas: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
    filtro: {
      type: Object,
    },
  },
  components: {
    PaginateComponent,
  },
  data() {
    return {
      headers: [
        { text: "Quantidade", value: "autos" },
        { text: "Enquadramento", value: "enquadramento" },
        { text: "Veículo", value: "veiculo_tipo" },
        { text: "Local", value: "infracao_logradouro" },
        { text: "Descrição", value: "descricao" },
      ],
    };
  },
  watch: {
    selected(newVal) {
      this.$emit("selected", [...newVal]);
    },
  },
  methods: {
    pagination(event) {
      this.$emit("input", event);
    },
    download() {
      const queryFilter = this.filtro
        ? `${queryString.stringify(this.filtro)}`
        : "";

      if (this.multas.data === undefined || this.multas.data.length === 0) {
        return this.$toasted.global.defaultError({
          msg: "Sem dados para exportar",
        });
      }

      const url = `${urlApi}/relatorio/ranking-multas/exportar?${queryFilter}`;
      this.$store.commit("overlay/toggle", true);
      this.$http
        .get(url)
        .then((res) => {
          var byteCharacters = atob(res.data.dados);
          const blob = new Blob([["\uFEFF" + byteCharacters]], {
            type: "text/csv;charset=UTF-18",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "relatorio-multas.infracao.csv";
          link.click();
          URL.revokeObjectURL(link.href);
          this.$store.commit("overlay/toggle", false);
          this.$toasted.global.defaultSuccess();
        })
        .catch((e) => {
          showError(e);
          this.$store.commit("overlay/toggle", false);
        });
    },
    mostraConsole() {
      console.log(this.multas);
    },
  },
  mounted() {
    this.mostraConsole();
  },
};
</script>
